import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import Loader from '../Utility/Loader/Loader';
import CustomDatePicker from '../Utility/DatePicker/DatePicker';

function DeletePopup({
  onOpen,
  onConfirm,
  message,
  secondMessage,
  toggle,
  title,
  loading,
  commentText,
  isCommentOn,
  showCheckBox,
  disabledBtn,
  showThirdMsg,
  thirdMessage,
  showDate,
  setSelectedDate,
  selectedDate,
  comment,
  showCommentHeader,
  isReferenceCode,
  code,
  handleRefrenceCode,
  isDuplicateLibrary,
  isDuplicatetemplate,
  handleDuplicateName,
  showDateError,
  isGrading,
  moduleName,
  isSpec,
  fromAccountDetails,
  fromSupplier,
  isFileBin,
}) {
  const [allowDelete, setAllowDelete] = useState(false);
  const deleteCompletly = (e) => {
    if (showCheckBox) {
      setAllowDelete(e.target.checked);
    }
  };
  const { t } = useTranslation('common');

  const handleDateChange = (e) => {
    setSelectedDate(e);
  };

  return (
    <Modal show={onOpen} backdrop="static" className="common-custom-modal modal-medium" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span>{title}</span>
        </Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {loading && <Loader />}
        {!loading && (
          <>
            <div className="modal-inner-data">
              <p className="mb-2 text-center">{t`${message}`}</p>
              {showCheckBox ? (
                <div className="common-checkbox">
                  <input type="checkbox" id="delConfirm" name="delConfirm" onChange={deleteCompletly} value="delete" />
                  <label htmlFor="delConfirm" className="chklabel delete-chklabel align-items-start">
                    <span>{secondMessage}</span>
                  </label>
                </div>
              ) : (
                secondMessage
              )}{' '}
              {showThirdMsg && (
                <span>
                  <p className="text-center">{thirdMessage}</p>
                </span>
              )}
              {showDate && (
                <div className="date justify-content-end px-1">
                  <div className="input-button-container">
                    <CustomDatePicker
                      dateFormat="dd-MMM-yyyy"
                      name="deliveryDate"
                      popperPlace="bottom-end"
                      placeholder={t('CONFIRMATION_POPUP.DELIVERY_DATE_LABEL')}
                      onChange={handleDateChange}
                      valueProp={selectedDate ? new Date(selectedDate) : null}
                    />
                  </div>
                  {!selectedDate && showDateError && <small className="error-message">{t('CONFIRMATION_POPUP.DELIVERY_DATE_REQUIRED')}</small>}
                </div>
              )}
              {isCommentOn && (
                <div className=" fixed-label">
                  {showCommentHeader && (
                    <label>
                      <strong>{t('CONFIRMATION_POPUP.COMMENT_LABEL')}</strong>
                    </label>
                  )}
                  <textarea
                    className="form-control mt-1 custom-textarea"
                    rows="3"
                    onChange={commentText}
                    value={comment}
                    placeholder={t('CONFIRMATION_POPUP.ENTER_COMMENT')}
                    maxLength={fromSupplier && 200}
                  />
                  <div className="text-count">{(fromSupplier && comment?.length) || 0}/200</div>
                </div>
              )}
              {isReferenceCode && (
                <div className=" fixed-label">
                  <label>
                    <strong>{t('CONFIRMATION_POPUP.REFERENCE_CODE_LABEL')}</strong>
                  </label>
                  <input className="form-control text-bordered" onChange={handleRefrenceCode} value={code} />
                </div>
              )}
              {isDuplicateLibrary && (
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    placeholder={isSpec ? t('CONFIRMATION_POPUP.CODE') : t('CONFIRMATION_POPUP.NAME')}
                    onChange={handleDuplicateName}
                    className="form-control"
                  />
                  <label className="f-14 asterisk-req">
                    {isGrading || isSpec ? moduleName : t('CONFIRMATION_POPUP.CUSTOM_MODULE_NAME_LABEL')} <span>*</span>
                  </label>
                </div>
              )}
              {isDuplicatetemplate && (
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    placeholder={isSpec ? t('CONFIRMATION_POPUP.CODE') : t('CONFIRMATION_POPUP.NAME')}
                    onChange={handleDuplicateName}
                    className="form-control"
                  />
                  <label className="f-14 asterisk-req">
                    {isGrading || isSpec ? moduleName : t('CONFIRMATION_POPUP.TEMPLATE_NAME')} <span>*</span>
                  </label>
                </div>
              )}
              {isFileBin && <span>{t('CONFIRMATION_POPUP.REMOVE_FOLDER_MESSAGE')}</span>}
            </div>
            {fromAccountDetails ? (
              <div className="common-model-footer">
                <button onClick={toggle} className="btn btn-default" type="button">
                  {t('CONFIRMATION_POPUP.OK')}
                </button>
              </div>
            ) : (
              <div className="common-model-footer">
                <button onClick={onConfirm} type="button" className="btn save-bom-configure" disabled={(showCheckBox && !allowDelete) || disabledBtn}>
                  {isDuplicateLibrary ? t('CONFIRMATION_POPUP.DUPLICATE_BUTTON') : <i className="icon-Tick-1 f-24" />}
                </button>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default DeletePopup;
